import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { savedTransactionStyles } from './saved-transaction-list-styles';

export const SavedTransactionCategoryHead = (): JSX.Element => {
  const classes = savedTransactionStyles();
  const { t } = useTranslation();

  return (
    <Grid container item justifyContent='flex-start' className={classes.outerContainerStyle}>
      <Grid item>
        <Grid container item>
          <Grid item className={`${classes.datePadding} ${classes.categoryHeadStyle}`}>
            <Typography variant='subtitle1'>{t('SearchResultsDataGrid_DateColumn')}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container item>
          <Grid item className={`${classes.posPadding} ${classes.categoryHeadStyle}`}>
            <Typography variant='subtitle1'>
              {t('SearchResultsDataGrid_TouchIdColumn').toUpperCase()}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container item>
          <Grid item className={`${classes.txnPadding} ${classes.categoryHeadStyle}`}>
            <Typography variant='subtitle1'>{t('TBR_Transaction_Category_Head')}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container item>
          <Grid item className={`${classes.amountPadding} ${classes.categoryHeadStyle}`}>
            <Typography variant='subtitle1'>{t('Amount')}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
